import { useRef, useState } from "react";

const SubsidiaryAppSurveyReadOnlyRow = ({ index, t, subsidiaryAppSurveyItem, handleDeleteClick, oddIdx, setError, handleSubmit }) => {
	const [isSubmit, setIsSubmit] = useState(false);
	const [isEditMode, setIsEditMode] = useState(false);
	const canReadRef = useRef(null);
	const [isCanRead, setIsCanRead] = useState(subsidiaryAppSurveyItem.canRead);
	const canWriteRef = useRef(null);
	const [isCanWrite, setIsCanWrite] = useState(subsidiaryAppSurveyItem.canWrite);
	const canReviewRef = useRef(null);
	const [isCanReview, setIsCanReview] = useState(subsidiaryAppSurveyItem.canReview);
	function submitComplete() {
		setIsSubmit(false);
	}

	function submitDelete(event, subsidiaryAppSurveyItem) {
		setError("");
		setIsSubmit(true);
		handleDeleteClick(event, subsidiaryAppSurveyItem, submitComplete);
	}

	const onResponseChange = (event) => {
		const { name, id } = event.target;
		if (name.startsWith("canRead_")) {
			setIsCanRead(event.target.checked);
		} else if (name.startsWith("canWrite_")) {
			setIsCanWrite(event.target.checked);
		} else if (name.startsWith("canReview_")) {
			setIsCanReview(event.target.checked);
		}
	}

	function handleEditClick(event) {
		setIsSubmit(false);
		setIsEditMode(true);
	}

	function submitUpdate(event, subsidiaryAppSurveyItem) {
		setError("");
		setIsSubmit(true);
		let updatedValues = {
			subsidiaryCompanyId : subsidiaryAppSurveyItem.subsidiaryCompanyId,
			appSurveyKey: subsidiaryAppSurveyItem.appSurveyKey,
			canRead: canReadRef.current.checked,
			canWrite: canWriteRef.current.checked,
			canReview: canReviewRef.current.checked,
		};
		handleSubmit(2, updatedValues, submitUpdateComplete);
	}
	function submitUpdateComplete() {
		setIsSubmit(false);
		setIsEditMode(false);
	}
	function submitCancel(event, subsidiaryAppSurveyItem) {
		setError("");
		setIsCanRead(subsidiaryAppSurveyItem.canRead);
		setIsCanWrite(subsidiaryAppSurveyItem.canWrite);
		setIsCanReview(subsidiaryAppSurveyItem.canReview);
		setIsEditMode(false);
		setIsSubmit(false);
	}
	return (
		<tr key={index}>
			<td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{subsidiaryAppSurveyItem.companyName}</td>
			<td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{subsidiaryAppSurveyItem.appDisplayName}</td>
			<td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{subsidiaryAppSurveyItem.surveyDisplayName}</td>
			{isEditMode ? (
				<>
					<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
						<input type="checkbox" className="mycheckbox"
							ref={canReadRef}
							name={"canRead_" + subsidiaryAppSurveyItem.appSurveyKey}
							id={"canRead_" + subsidiaryAppSurveyItem.appSurveyKey}
							defaultChecked={true}
							checked={isCanRead}
							onChange={onResponseChange}
						/>
					</td>
					<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
						<input type="checkbox" className="mycheckbox"
							ref={canWriteRef}
							name={"canWrite_" + subsidiaryAppSurveyItem.appSurveyKey}
							id={"canWrite_" + subsidiaryAppSurveyItem.appSurveyKey}
							defaultChecked={true}
							checked={isCanWrite}
							onChange={onResponseChange}
						/>
					</td>
					<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
						<input type="checkbox" className="mycheckbox"
							ref={canReviewRef}
							name={"canReview_" + subsidiaryAppSurveyItem.appSurveyKey}
							id={"canReview_" + subsidiaryAppSurveyItem.appSurveyKey}
							defaultChecked={true}
							checked={isCanReview}
							onChange={onResponseChange}
						/>
					</td>
				</>


			) : (
				<>
					<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{""+subsidiaryAppSurveyItem.canRead}</td>
					<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{""+subsidiaryAppSurveyItem.canWrite}</td>
					<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{""+subsidiaryAppSurveyItem.canReview}</td>
				</>
			)}
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{subsidiaryAppSurveyItem.status}</td>
			<td className={oddIdx ? "list-td col col-md-auto odd" : "list-td col col-md-auto even"}>
				<div id="submit-spinner"
					className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
				>
				</div>
				{isEditMode ? (
					<>
						<button className={isSubmit ? "btn btn-primary btn-block me-2 mb-1 pe-none" : "btn btn-primary btn-block me-2 mb-1"}
							onClick={(event) => submitUpdate(event, subsidiaryAppSurveyItem)}>{t("page.submit")}</button>
						<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"}
							onClick={(event) => (submitCancel(event, subsidiaryAppSurveyItem))}>{t("page.cancel")}</button>
					</>
				) : (
					<>
						<button className={isSubmit ? "btn btn-primary btn-block me-2 mb-1 pe-none" : "btn btn-primary btn-block me-2 mb-1"}
							onClick={(event) => handleEditClick(event)}>{t("page.edit")}</button>
						<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-2 mb-1"} onClick={(event) => submitDelete(event, subsidiaryAppSurveyItem)}>
							{subsidiaryAppSurveyItem.statusCode === 1 ? t("page.delete") : t("page.undelete")}</button>
					</>
				)}

			</td>
		</tr>
	)
}
export default SubsidiaryAppSurveyReadOnlyRow;